export const handleVendorPendingPaymentPrint = async (
  vendorId,
  fetchVendorPendingPayments,
  printType = "both" // "cod", "charge", or "both"
) => {
  try {
    const result = await fetchVendorPendingPayments({ vendorId });

    if (result.error) {
      throw new Error(result.error.message || "Failed to fetch data");
    }
    const pendingPaymentsRes = result.data;
    const pendingPayments = pendingPaymentsRes?.data || [];

    const totalCODAmount = pendingPaymentsRes?.totalCODAmount || 0;
    const totalChargeAmount = pendingPaymentsRes?.totalChargeAmount || 0;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    // Determine what to show based on printType
    const showCOD = printType === "cod" || printType === "both";
    const showCharge = printType === "charge" || printType === "both";

    // Dynamic title based on print type
    let invoiceTitle = "Pending Payment Invoice";
    if (printType === "cod") {
      invoiceTitle = "Pending COD Invoice";
    } else if (printType === "charge") {
      invoiceTitle = "Pending Charge Invoice";
    }

    doc.open();
    doc.write(`
      <html>
        <head>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            .header-row {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              margin-bottom: 10px;
            }
            .company-info {
              flex: 1;
            }
            .vendor-info {
              text-align: right;
              font-weight: bold;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: right;
            }
            th {
              background: #1976d2;
              color: #fff;
            }
            td:first-child,
            td:nth-child(2),
            th:first-child,
            th:nth-child(2) {
              text-align: left;
            }
            td:nth-child(3),
            th:nth-child(3) {
              text-align: center;
            }
            .total {
              font-weight: bold;
            }
          </style>
        </head>
        <body>
          <div class="header-row">
            <div class="company-info">
              <h2 style="margin: 0;">${pendingPaymentsRes?.entityName || "Company"}</h2>
              <p style="margin: 5px 0;">${pendingPaymentsRes?.entityLocation || ""}</p>
            </div>
            <div class="vendor-info">
              <h3 style="margin: 0;">${invoiceTitle}</h3>
              <p style="margin: 5px 0;">OwnerName (Vendor): ${pendingPaymentsRes?.vendorOwnerName || "N/A"}</p>
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th>SN</th>
                <th>Shipment ID</th>
                <th>Shipment Status</th>
                ${showCOD ? '<th>COD</th>' : ''}
                ${showCharge ? '<th>Charge</th>' : ''}
                <th>Created Date</th>
              </tr>
            </thead>
            <tbody>
              ${pendingPayments
        .map(
          (p, i) => `
                <tr>
                  <td>${i + 1}</td>
                  <td>${p.shipmentId}</td>
                  <td>${p.shipmentStatus || 'N/A'}</td>
                  ${showCOD ? `<td>${p.codAmount.toFixed(2)}</td>` : ''}
                  ${showCharge ? `<td>${p.chargeAmount.toFixed(2)}</td>` : ''}
                  <td>${p.createdAt ? new Date(p.createdAt).toLocaleDateString() : 'N/A'}</td>
                </tr>
              `
        )
        .join("")}
              <tr class="total">
                <td colspan="3">Total</td>
                ${showCOD ? `<td>Rs ${totalCODAmount.toFixed(2)}</td>` : ''}
                ${showCharge ? `<td>Rs ${totalChargeAmount.toFixed(2)}</td>` : ''}
                <td></td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    `);
    doc.close();

    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }, 500);

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1500);

    return {
      totalCODAmount,
      totalChargeAmount,
    };
  } catch (error) {
    console.error("Print failed:", error);
    return {
      totalCODAmount: 0,
      totalChargeAmount: 0,
    };
  }
};